var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorld(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.879,
    height: 42.879,
    viewBox: "0 0 42.879 42.879",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "world",
    d: "M21.44,0a21.44,21.44,0,1,0,21.44,21.44A21.44,21.44,0,0,0,21.44,0ZM39.306,21.44a17.756,17.756,0,0,1-2.969,9.841l-2.13-2.131a.893.893,0,0,1-.261-.631V26.8a5.36,5.36,0,0,0-5.36-5.36h-5.36a1.787,1.787,0,0,1-1.787-1.787V18.76a.893.893,0,0,1,.893-.893A4.467,4.467,0,0,0,26.8,13.4V11.613a.893.893,0,0,1,.893-.893h2.464a4.5,4.5,0,0,0,3.157-1.308l.674-.674A17.811,17.811,0,0,1,39.306,21.44ZM3.661,23.16,9.3,28.8a5.321,5.321,0,0,0,3.791,1.57h4.772a1.787,1.787,0,0,1,1.787,1.787v7.055A17.9,17.9,0,0,1,3.661,23.16ZM23.226,39.215V32.159a5.36,5.36,0,0,0-5.36-5.36H13.094a1.787,1.787,0,0,1-1.265-.523L3.864,18.311A17.827,17.827,0,0,1,31.187,6.485l-.4.4a.906.906,0,0,1-.631.261H27.693a4.467,4.467,0,0,0-4.467,4.467V13.4a.893.893,0,0,1-.893.893,4.467,4.467,0,0,0-4.467,4.467v.893a5.36,5.36,0,0,0,5.36,5.36h5.36A1.787,1.787,0,0,1,30.373,26.8v1.719a4.5,4.5,0,0,0,1.308,3.157l2.389,2.389a17.814,17.814,0,0,1-10.843,5.151Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorld);
export default __webpack_public_path__ + "static/media/world.bda60de5361b76c6a0b152a95951f7ad.svg";
export { ForwardRef as ReactComponent };